import React, { useState, useEffect } from "react";
import Modal from "../Modal";

const UpdateOrderDetails = ({ isOpen, onClose, order, handleUpdateOrderDetails }) => {
  const [formData, setFormData] = useState({
    paymentMethod: "",
    weight: "",
    length: "",
    breadth: "",
    height: "",
    codAmount: "",
  });

  useEffect(() => {
    if (order) {
      setFormData({
        paymentMethod: order?.paymentDetails?.method || "",
        weight: order?.packageDetails?.applicableWeight || "",
        length: order?.packageDetails?.volumetricWeight?.length || "",
        breadth: order?.packageDetails?.volumetricWeight?.width || "",
        height: order?.packageDetails?.volumetricWeight?.height || "",
        codAmount: order?.paymentDetails?.amount || "",
      });
    }
  }, [order, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleUpdateOrderDetails(formData); // Call update function
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={<span className="sm:text-[14px] text-[12px] font-[600] p-2 text-gray-700">Update Order Details</span>}>
      <form className="grid grid-cols-3 gap-4 text-[10px] sm:text-[12px] font-[600] text-gray-500" onSubmit={handleSubmit}>
        {/* Payment Method */}
        <div>
          <label className="block font-[600] mb-1">Payment Method</label>
          <select
            name="paymentMethod"
            value={formData.paymentMethod}
            onChange={handleChange}
            className="w-full px-3 h-9 rounded-lg border-2 focus:outline-green-200"
          >
            <option value="Prepaid">Prepaid</option>
            <option value="COD">Cash on Delivery</option>
          </select>
        </div>

        {/* Weight */}
        <div>
          <label className="block font-[600] mb-1">Weight (kg)</label>
          <input
            type="number"
            name="weight"
            value={formData.weight}
            onChange={handleChange}
            className="w-full h-9 px-3 rounded-lg border-2 focus:outline-green-200"
            min="0"
            step="0.01"
          />
        </div>

        {/* Dimensions */}
        <div>
          <label className="block font-[600] mb-1">Length (cm)</label>
          <input
            type="number"
            name="length"
            value={formData.length}
            onChange={handleChange}
            className="w-full h-9 px-3 rounded-lg border-2 focus:outline-green-200"
            min="0"
            step="0.1"
          />
        </div>

        <div>
          <label className="block font-[600] mb-1">Breadth (cm)</label>
          <input
            type="number"
            name="breadth"
            value={formData.breadth}
            onChange={handleChange}
            className="w-full h-9 px-3 rounded-lg border-2 focus:outline-green-200"
            min="0"
            step="0.1"
          />
        </div>

        <div>
          <label className="block font-[600] mb-1">Height (cm)</label>
          <input
            type="number"
            name="height"
            value={formData.height}
            onChange={handleChange}
            className="w-full h-9 px-3 rounded-lg border-2 focus:outline-green-200"
            min="0"
            step="0.1"
          />
        </div>

        {/* COD Amount */}
        <div>
          <label className="block font-[600] mb-1">COD Amount</label>
          <input
            type="number"
            name="codAmount"
            value={formData.codAmount}
            onChange={handleChange}
            className="w-full h-9 px-3 rounded-lg border-2 focus:outline-green-200"
            min="0"
            step="0.01"
          />
        </div>

        {/* Submit Button */}
        <div className="col-span-3 text-right">
          <button type="submit" className="bg-[#632C9D] text-[10px] sm:text-[12px] font-[600] text-white px-3 py-2 rounded-lg hover:bg-purple-500">
            Save
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateOrderDetails;
